export const GA_MEASUREMENT_ID = "G-94XL5VWFS3"
export const ANALYTICS_CONSENT_COOKIE = "gatsby-gdpr-google-analytics"

// Only ever send hits from the real production domain. Localhost and Netlify
// deploy previews would otherwise mint their own _ga client id and show up as
// separate "users" in GA4 Realtime.
export const ANALYTICS_HOSTS = ["compoundyourself.com", "www.compoundyourself.com"]

let loadPromise = null

export function hasAnalyticsConsent() {
  if (typeof document === "undefined") return false

  return document.cookie
    .split(";")
    .some(cookie => cookie.trim() === `${ANALYTICS_CONSENT_COOKIE}=true`)
}

export function isAnalyticsHost() {
  if (typeof window === "undefined") return false

  return ANALYTICS_HOSTS.includes(window.location.hostname)
}

export function loadGoogleAnalytics() {
  if (typeof window === "undefined") return Promise.resolve(false)
  if (!isAnalyticsHost()) return Promise.resolve(false)
  if (typeof window.gtag === "function") return Promise.resolve(true)
  if (loadPromise) return loadPromise

  loadPromise = new Promise(resolve => {
    window.dataLayer = window.dataLayer || []
    window.gtag = function gtag() {
      window.dataLayer.push(arguments)
    }
    window.gtag("js", new Date())

    const script = document.createElement("script")
    script.async = true
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`
    script.onload = () => {
      window.gtag("config", GA_MEASUREMENT_ID, {
        send_page_view: false,
      })
      resolve(true)
    }
    script.onerror = () => resolve(false)
    document.head.appendChild(script)
  })

  return loadPromise
}

export function trackPageView(pagePath) {
  if (typeof window.gtag !== "function") return

  window.gtag("event", "page_view", {
    page_path: pagePath,
  })
}

export async function initAnalyticsIfConsented(pagePath) {
  if (!hasAnalyticsConsent()) return

  const loaded = await loadGoogleAnalytics()
  if (loaded) trackPageView(pagePath)
}
